import React from 'react';
import { Button } from 'seagull';
import styles from "./PresetButton.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const PresetButton = _ref => {
  let {
    onClick,
    disabled,
    testId,
    text
  } = _ref;
  return /*#__PURE__*/_jsx(Button, {
    skin: "primaryOutline",
    size: "small",
    onClick: onClick,
    disabled: disabled,
    "data-testid": testId,
    className: styles.presetButton,
    children: text
  });
};
export default PresetButton;